import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { string, func, array, bool, number, object } from 'prop-types'
import Editor from './editor'
import {
	editTemplateText,
	editTemplateCkeditorCss,
	editTemplateCkeditorStyles,
} from '~/states/modules/editTemplate'
import styled from 'styled-components'
import Tabs from './tabs'

const generateUniqueId = () => {
	const timestamp = new Date().getTime() // Get current time in milliseconds
	const uniqueId = `editor-${timestamp}` // Prefix the timestamp with "editor-"
	return uniqueId
}

/**
 * Renders the CSS and Styles editing component, under the Styles Tab on the template configuration page.
 *
 * @param {string} data - The template base html.
 * @param {string} ckeditorStyles - The CKEditor styles for the component.
 * @param {string} ckeditorCss - The CKEditor CSS for the component.
 */
const Styles = ({ data, ckeditorStyles, ckeditorCss }) => {
	const dispatch = useDispatch()
	const [id, setId] = useState(generateUniqueId())

	const updateText = (e) => {
		let value = e
		if (e.target) {
			value = e.target.value
		}
		dispatch(editTemplateText({ value }))
	}

	const [currentCss, setCurrentCss] = useState(ckeditorCss)
	const [currentStyles, setCurrentStyles] = useState(ckeditorStyles)

	const updateCkeditorCss = (e) => {
		let value = e
		if (e.target) {
			value = e.target.value
		}

		setCurrentCss(value)
		dispatch(editTemplateCkeditorCss({ value }))
	}

	const updateCkeditorStyles = (e) => {
		let value = e
		if (e.target) {
			value = e.target.value
		}
		setCurrentStyles(value)
		dispatch(editTemplateCkeditorStyles({ value }))
		setId(generateUniqueId())
	}

	return (
		<div
			style={{
				display: 'flex',
				gap: '40px',
				height: '100%',
				paddingBottom: ' 20px',
			}}>
			<WidgetWrapper>
				<Tabs
					setId={setId}
					updateCkeditorStyles={updateCkeditorStyles}
					updateCkeditorCss={updateCkeditorCss}
					ckeditorStyles={ckeditorStyles}
					ckeditorCss={ckeditorCss}
					currentCss={currentCss}
				/>
			</WidgetWrapper>
			<Editor
				text={data}
				onUpdateText={updateText}
				textVariable={''}
				ckeditorStyles={currentStyles}
				ckeditorCss={currentCss}
				id={id}
			/>
		</div>
	)
}

export default Styles

Styles.propTypes = {
	data: string,
	updateForm: func,
	files: array,
	updateFile: func,
	setDownloadButton: func,
	setInputsFilled: func,
	docPosted: bool,
	removeDoc: func,
	widgetIndexes: number,
	ckeditorCss: string,
	ckeditorStyles: object,
}

const WidgetWrapper = styled.div`
	min-width: 600px;
	width: 640px;

	.ant-tabs.ant-tabs-top,
	.ant-tabs.ant-tabs-top.ant-tabs-mobile,
	.ant-tabs-content.ant-tabs-content-top {
		height: 100%;
	}
`
